/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Savings = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M19 1V6.5H18.001L18.0011 7.53577C19.1961 8.22755 20 9.51989 20 11V23H4V11C4 9.51949 4.80434 8.22683 5.99988 7.5352L5.999 6.5H5V1H19ZM16.501 6.5H7.499L7.49984 8.40037L6.75101 8.83358C5.98217 9.27837 5.5 10.0964 5.5 11V21.5H18.5V11C18.5 10.1569 18.0802 9.38825 17.3994 8.9278L17.2496 8.83394L16.5015 8.40086L16.501 6.5ZM12.564 10.765V11.584C13.671 11.773 14.391 12.493 14.445 13.537H13.077C13.005 13.141 12.618 12.763 11.988 12.763C11.448 12.763 11.124 12.979 11.124 13.348C11.124 13.681 11.376 13.843 11.754 13.951L12.735 14.221C13.671 14.491 14.481 14.914 14.481 16.219C14.481 17.254 13.743 17.983 12.564 18.136V19H11.421V18.109C10.269 17.893 9.504 17.056 9.45 15.85H10.818C10.872 16.471 11.394 16.957 12.06 16.957C12.654 16.957 13.059 16.678 13.059 16.255C13.059 15.886 12.762 15.67 12.366 15.553L11.394 15.283C10.467 15.031 9.693 14.563 9.693 13.357C9.693 12.457 10.395 11.773 11.421 11.584V10.765H12.564ZM17.5 2.5H6.5V5H17.5V2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
